/**
 * True when the selected range end is strictly before `now`, so moving the end
 * to `now` would include newer data. Used by structured-search refresh flows.
 */
export const isSelectedEndTimeBeforeNow = (end: Date, now: Date = new Date()): boolean => {
  const endMs = end.getTime();
  const nowMs = now.getTime();
  return Number.isFinite(endMs) && Number.isFinite(nowMs) && endMs < nowMs;
};
